import "./App.css";
import { useEffect } from "react";
import * as ReactGA from "react-ga";
import TagManager from 'react-gtm-module';

import { Route, Routes, useLocation } from "react-router-dom";

import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import PageNotFound from "./pages/PageNotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import Surveys from "./pages/Surveys";
import CookieConsentPopup from "./components/CookieConsentPopup";
import HowToConductUserFeedbackInterview from "./pages/blogs/how-to-conduct-user-feedback-interview";
import HowToConductUserFeedbackSurvey from "./pages/blogs/how-to-conduct-user-feedback-surveys";
import HowToBetaTestProduct from "./pages/blogs/how-to-beta-test-product";
import HowToValidateStartupIdea from "./pages/blogs/how-to-validate-startup-idea";
import HowCEOcanCollaborateWithCTO from "./pages/blogs/how-ceo-can-collaborate-with-cto";
import HowToDiscoverInterviewsPart2 from "./pages/blogs/how-to-do-discovery-interviews-customer-interview-questions";
import HowToDiscoverInterviewsPart1 from "./pages/blogs/how-to-do-discovery-interviews-find-the-right-customers";
import DeadlySinsOfCustomeInterviews from "./pages/blogs/7-deadly-sins-of-customer-interviews";
import IntroducingMagicAISurveys from "./pages/blogs/introducing-magic-ai-surveys";
import CreateYourFirstAISurvey from "./pages/blogs/create-your-first-ai-survey";
import HowToBuildBetterProductByCreatingAStrongStory from "./pages/blogs/how-to-build-better-products-by-creating-a-strong-story";

function App() {
    const hasConsent = localStorage.getItem("cookiesAccepted");

    const location = useLocation();

    const tagManagerArgs = {
        gtmId: 'GTM-KB9KMBGZ'
    }

    useEffect(() => {
        TagManager.initialize(tagManagerArgs)
    }, []);

    useEffect(() => {
        // Scroll to the top of the page when the location (route) changes
        window.scrollTo(0, 0);
        ReactGA.pageview(location.pathname + location.search);
    }, [location]);

    return (
        <div className="App">
            <main>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/ai-surveys" element={<Surveys />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/how-to-conduct-user-interviews-as-a-product-manager" element={<HowToConductUserFeedbackInterview />} />
                    <Route path="/blog/how-to-conduct-user-surveys-as-a-product-manager" element={<HowToConductUserFeedbackSurvey />} />
                    <Route path="/blog/beta-testing-as-a-product-manager" element={<HowToBetaTestProduct />} />
                    <Route path="/blog/how-to-validate-startup-idea" element={<HowToValidateStartupIdea />} />
                    <Route path="/blog/how-ceo-can-collaborate-with-cto" element={<HowCEOcanCollaborateWithCTO />} />
                    <Route path="/blog/how-to-do-discovery-interviews-find-the-right-customers" element={<HowToDiscoverInterviewsPart1 />} />
                    <Route path="/blog/how-to-do-discovery-interviews-customer-interview-questions" element={<HowToDiscoverInterviewsPart2 />} />
                    <Route path="/blog/6-biggest-customer-interview-mistakes" element={<DeadlySinsOfCustomeInterviews />} />
                    <Route path="/blog/demo/introducing-magic-ai-surveys" element={<IntroducingMagicAISurveys />} />
                    <Route path="/blog/demo/create-your-first-ai-survey" element={<CreateYourFirstAISurvey />} />
                    <Route path="/blog/though-leadership/how-to-build-better-products-by-creating-a-strong-story" element={<HowToBuildBetterProductByCreatingAStrongStory />} />
                    <Route path="/schedule-demo" element={<Contact />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-of-use" element={<TermsOfUse />} />
                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </main>
            <Footer />
            {!hasConsent && <CookieConsentPopup />}
        </div>
    );
}

export default App;
